const { getElements } = window.BAO.Utils

class WishlistEdit extends window.BAO.CustomElement() {
  static requiredElements () {
    return [
      'colour-input',
      'edit',
      'form',
      'colour',
      'colours',
      'title',
      'title-container',
      'trigger',
    ]
  }

  setupListeners () {
    super.setupListeners()

    this.onFormSubmit = this.onFormSubmit.bind(this)
    this.onColourClick = this.onColourClick.bind(this)
    this.onTriggerClick = this.onTriggerClick.bind(this)

    this.listeners.add(this.els.form.element, 'submit', this.onFormSubmit)
    this.listeners.add(this, 'click', this.onColourClick)

    if (this.els?.trigger?.exists) {
      this.listeners.add(this.els.trigger.element, 'click', this.onTriggerClick)
    }
  }

  async onFormSubmit (event) {
    event.preventDefault()

    const formData = new FormData(event.target)

    const res = await window.BAO.wishlist.updateList(
      this.dataset.wishlistId,
      formData,
      window.BAO.wishlist.token,
    )

    if (this.els?.title.element) {
      this.els.title.element.textContent = `${res.name} (${this.els.title.element.dataset.wishlistCount})`
    }

    this.els['title-container'].element.setAttribute('aria-hidden', 'false')
    this.els.edit.element.setAttribute('aria-hidden', 'true')
    this.externalEls?.body?.element?.classList.remove(
      this.wishlistEditClassName,
    )
  }

  onColourClick (event) {
    const target = event.target.closest(this.els.colour.selector)
    if (!target) return

    const colour = target.querySelector(`[data-id]`)
    if (!colour) return

    const colours = getElements(`[data-id]`, {
      context: this.els.colours.element,
    })
    colours.forEach(el =>
      el.setAttribute('aria-selected', (el === colour).toString()),
    )

    this.els['colour-input'].element.value = colour.dataset.id
  }

  onTriggerClick () {
    this.els['title-container'].element.setAttribute('aria-hidden', 'true')
    this.els.edit.element.setAttribute('aria-hidden', 'false')
    this.externalEls?.body?.element?.classList.add(this.wishlistEditClassName)
  }

  get wishlistEditClassName () {
    return 'wlt-List-edit'
  }
}

customElements.define('wishlist-edit', WishlistEdit)
